module.exports = __webpack_public_path__ + "static/media/garage-car.158e86db.svg";